// Images inside a closed <dialog> are display:none, so lazysizes never sees
// them and the fetch only starts once the dialog opens — a visible delay.
// Warm them on intent instead: hover/focus/touch on the trigger is enough
// lead time that the image is usually decoded before the click lands.
const preloadDialogImages = ($dialog) => {
    const loader = window.lazySizes && window.lazySizes.loader

    if (!loader) {
        return
    }

    $dialog.querySelectorAll('img.lazyload').forEach(($img) => loader.unveil($img))
}

document.querySelectorAll('[data-dialog]').forEach(($trigger) => {
    const id = $trigger.getAttribute('data-dialog')
    const $dialog = document.getElementById(id)

    if (!$dialog) {
        return
    }

    $trigger.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        // The dialog's own x-effect is what actually calls showModal() - see
        // _atoms/dialog.twig - so x-trap.inert.noscroll can lock the main
        // window's scroll off the same reactive flag.
        window.Alpine.$data($dialog).open = true

        $dialog.dispatchEvent(new CustomEvent('shape:rebuild', { bubbles: true }))

        $dialog.querySelectorAll('.fui-input').forEach(($input) => {
            const type = $input.getAttribute('type')

            if (
                $input.hasAttribute('placeholder') ||
                type === 'hidden' ||
                type === 'radio' ||
                type === 'checkbox'
            ) {
                return
            }

            $input.setAttribute('placeholder', 'Enter')
        })

        // Images inside a closed <dialog> never get sizes, so lazysizes
        // leaves the placeholder. Unveil them now the dialog is open.
        $dialog.querySelectorAll('img.lazyload').forEach((img) => {
            window.lazySizes?.loader.unveil(img)
        })
    })
})

document.querySelectorAll('dialog.dialog').forEach(($dialog) => {
    const $close = $dialog.querySelector('.dialog__close')
    const $curtainClose = $dialog.querySelector('.dialog__curtain-close')

    $close?.addEventListener('click', () => {
        $dialog.close()
    })

    $curtainClose?.addEventListener('click', () => {
        $dialog.close()
    })
})
